export default __webpack_public_path__ + "static/media/environment and me.3c335690.png";